import React, {useEffect} from "react";

const SmiWidget = ({isFull, isDesktop, blockIds}) => {
    if (!blockIds) {
        return null
    }

    const blockId = isFull ? (isDesktop ? blockIds.fullPc : blockIds.fullMob) : (isDesktop ? blockIds.prevPc : blockIds.prevMob)

    if (!blockId) {
        return null;
    }

    useEffect(() => {
        (window.smiq = window.smiq || []).push({});
    }, []);

    return <div className="smi24__informer smi24__auto" data-smi-blockid={blockId}></div>;
};

export default SmiWidget;
